import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ar from './locales/ar.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { ar: { translation: ar }, en: { translation: en } },
    fallbackLng: 'ar',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'solou-lang',
    },
  });

// تحديث اتجاه الصفحة عند تغيير اللغة
const updateDirection = (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
  document.body.style.direction = dir;
  document.body.style.textAlign = lng === 'ar' ? 'right' : 'left';
};

const resolvedLang = (i18n.language || 'ar').startsWith('ar') ? 'ar' : (i18n.language || 'ar');
updateDirection(resolvedLang);
i18n.on('languageChanged', updateDirection);

export default i18n;
